import React from "react";
import GenericChart from "../GenericChart";
import { View } from "../../../../../components/Common/react-native-components";

const SentimentProgressBar = (props) => {
    const { row, chartDefaultConfig } = props

    const series = [
        {
            name: 'Negative',
            data: [row?.num_sentiment_negative_count || 0],
            color: '#e26067'
        },
        {
            name: 'Neutral',
            data: [row?.num_sentiment_neutral_count || 0],
            color: '#9ea6b3'
        },
        {
            name: 'Positive',
            data: [row?.num_sentiment_positive_count || 0],
            color: '#5ec871'
        },
    ]

    return (
        <View style={{ justifyContent: "center", paddingHorizontal: 10, width: "400px" }}>
            <div style={{ padding: 0, height: "14px", borderRadius: "50px", overflow: "hidden" }}>
                <GenericChart
                    defaultConfig={chartDefaultConfig}
                    series={series}
                    tooltipValueKeysConfig={{
                        isheaderVisible: false
                    }}
                />
            </div>
        </View>
    )
}
export default SentimentProgressBar